import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { showProgress } from '../../../redux/actions/DealershipActions';
import { ErrorToast } from '../../utils/Utils';

const useDetails = () => {
  const dispatch = useDispatch();
  const [instrList, setInstrList] = useState([]);
  const [plans, setPlans] = useState([]);
  const getPlan = useCallback(async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.GET_PLANS);
      const temp = res?.map(({ id, title }) => ({ value: id, label: title })) ?? [];
      setPlans(temp);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  }, [dispatch]);

  const getInstructors = useCallback(
    async (storyType) => {
      await service
        .get(apiEndpoints.STORY_DOSE_BY_TYPE.replace('DOSE_TYPE', storyType))
        .then((output) => {
          setInstrList(output);
          dispatch(showProgress(false));
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
        });
    },
    [dispatch],
  );

  useEffect(() => {
    getPlan();
  }, [getPlan]);
  return { instrList, plans, getInstructors };
};

export default useDetails;
